var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SGPTabsMenuHorizontalComponent',{attrs:{"itemsTabs":_vm.itemsTabs,"propsPage":{ itemsVertical: _vm.itemsVertical },"vertical":""}}),(_vm.loadingTarefasMobilidades)?_c('SGPLoadingComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }